<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ $t('requestToPay.payment_mode_slct') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row style="align-items:stretch;">
                <b-col sm="5" class="modal-action" :class="choice === 1 ? 'modal-action-selected' : ''"
                  @click="selectChoice(1)">
                  <b-container fluid>
                    <b-row style="margin-bottom:20px;text-align:center;">
                      <b-col>
                        <span class="modal-action-title">{{ $t('requestToPay.pay_once') }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span class="modal-action-text">{{ $t('common.amnt') }} : {{ data.amount }} {{ getCurrencyIcon(data.currency) }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span class="modal-action-text">{{ $t('common.dt') }} : {{ data.requestedExecutionDate | formatDateTime }}</span>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
                <b-col sm="7" class="modal-action modal-action-right" :class="choice === 2 ? 'modal-action-selected' : ''"
                  @click="selectChoice(2)">
                  <b-container fluid>
                    <b-row style="margin-bottom:20px;text-align:center;">
                      <b-col>
                        <span class="modal-action-title">{{ $t('requestToPay.pay_installment') }}</span>
                      </b-col>
                    </b-row>
                    <div v-for="(installment, installmentIndex) in data.installments" :key="installmentIndex"
                      :style="installmentIndex > 0 ? 'margin-top:2rem;' : ''">
                      <b-row>
                        <b-col>
                          <span class="modal-action-subtitle">{{ $t('requestToPay.instalment') }} {{ installmentIndex + 1 }}</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <span class="modal-action-text">{{ $t('common.amnt') }} : {{ installment.Amount }} {{ getCurrencyIcon(installment.Currency) }}</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <span class="modal-action-text">{{$t('common.dt')}} : {{ installment.Date | formatDateTime }}</span>
                        </b-col>
                      </b-row>
                    </div>
                  </b-container>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 m-0">
              <b-button variant="primary" :disabled="choice === 0"
                @click="confirmChoice()">
                {{ $t('common.accpt') }}
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import moment from 'moment'

export default {
  name: 'ChoicePaymentInstalment',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      choice: 0,
      mousedown: false
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        case 'HUF':
          return 'Ft'
        default:
          return ccy
      }
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    confirmChoice () {
      this.$emit('close')
      if (this.choice === 1) {
        this.data.oneTimePayment = '1'
        if (!this.data.hasOriginalAmountChanged && !this.data.hasOriginalDateChanged) {
          this.data.status = '10'
        }
      } else {
        this.data.acceptInstallments = '1'
      }

      this.$bus.$emit('answer-to-payments', this.data)
    },
    selectChoice (choice) {
      this.choice = choice
    }
  }
}
</script>
<style scoped>
.modal-action {
  cursor: pointer;
  padding: 10px;
}
.modal-action:hover, .modal-action-selected {
  background-color: rgba(50, 50, 50, 0.1);
}
.modal-action-title {
  font-size: 16px;
}
.modal-action-subtitle {
  font-size: 16px;
  font-weight: bold;
}
.modal-action-text {
  font-size: 14px;
}
@media (max-width: 575px) {
  .modal-action-right {
    border-top: 1px solid #000;
  }
}
@media (min-width: 576px) {
  .modal-action-right {
    border-left: 1px solid #000;
  }
}
</style>
